import { create } from 'zustand';

/**
 * Global "is something loading" counter that drives the {@link TopLoadingBar}.
 *
 * It's a counter rather than a boolean so multiple concurrent loads (e.g. two
 * Suspense boundaries, or a route chunk + a data fetch) coexist — the bar stays
 * up until the LAST one finishes. `begin()`/`end()` are always paired.
 */
interface LoadingState {
  count: number;
  begin: () => void;
  end: () => void;
}

export const useLoadingStore = create<LoadingState>((set) => ({
  count: 0,
  begin: () => set((s) => ({ count: s.count + 1 })),
  end: () => set((s) => ({ count: Math.max(0, s.count - 1) })),
}));

/** True while at least one load is in flight. */
export const selectIsLoading = (s: LoadingState) => s.count > 0;
